const jQ = jQuery.noConflict();

function wrapCheckboxLabelText() {
    if(jQ('#ss_wc_mailchimp_opt_in span').length == 0){
        jQ('#ss_wc_mailchimp_opt_in').after('<span></span>');
    }
}

function removeTimesFromShipping() {
    const label = jQ('.shop_table .shipping label');

    label.each(function(){
        const txt = jQ(this).html();
        const mod = txt.replace(':', '');
        jQ(this).html(mod);

    });
}

function onUpdateCheckout() {
    jQ( 'body' ).on( 'updated_checkout', function() {
        wrapCheckboxLabelText();
        removeTimesFromShipping();
    });
}

function toggleInvoiceFields() {
    jQ('form.woocommerce-checkout').on('change', 'input[name="invoice"]' , function() {
        const fields = jQ('.invoice-additional-fields');
        if(this.checked) {
            fields.addClass('visible');
        } else {
            fields.removeClass('visible');
        }
    });
}
export {onUpdateCheckout, wrapCheckboxLabelText, removeTimesFromShipping, toggleInvoiceFields};
